import { NEXT_LOCALE_COOKIE } from '@partment/types'
import { setCookie } from 'cookies-next/client'

export async function setUserLocale(locale: string) {
  setCookie(NEXT_LOCALE_COOKIE, locale, {
    path: '/',
    secure: process.env.NODE_ENV === 'production',
    sameSite: 'lax',
    maxAge: 60 * 60 * 24 * 30,
  })

  window.location.reload()
}
